import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { IUIDefaultViewModel } from "../../services/ui-personalization-data-service/Models";
import { keys } from "./Keys";


export type UseUserDefaultViewParameters = {
} & BaseUseQueryParameters<IUIDefaultViewModel[]>;

export function useUserDefaultViews({
    enabled,
    onError,
    onSuccess
}: UseUserDefaultViewParameters) {
    return useQuery<IUIDefaultViewModel[], RestError>(
        keys.list(),
        async ({ signal }) => {
            return UIPersonalizationDataService.getUserDefaultViews(signal);
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess
        }
    );
}